import React, { memo, Fragment, useEffect, useCallback } from 'react';
import { FormInput } from '@core/components/form';
import { useObservable, useNonNilObservable } from '@core/utils/hooks/rxjs';
import { Col, Row, Label } from 'reactstrap';
import { FormRadio, FormRadioGroup } from '@core/components/form/FormRadio';
import { SortableList } from '@modules/common/Sortable';
import { SortableElement, SortableHandle, SortEnd } from 'react-sortable-hoc';
import { R } from '@core/utils/r';
import { ScenarioAnswerForm, ScenarioForm } from './MultipleChoiceTestBlock';

export interface ScenarioDrillItemProps {
  control: ScenarioForm;
}

export const ScenarioDrillItem = memo((props: ScenarioDrillItemProps) => {
  const { control } = props;
  const answers = useObservable(control.controls.answers.items$, []);
  const answerValues = useObservable(control.controls.answers.value$, []);

  useEffect(() => {
    if (answers.length === 0) {
      control.controls.answers.push();
    }
  }, [control.controls.answers, answers]);

  const onSortEnd = useCallback(
    (sort: SortEnd) => {
      const oldIndex = sort.oldIndex;
      const newIndex = sort.newIndex;
      const newAnswers = R.move(answerValues, oldIndex, newIndex);
      control.patchValue({
        answers: newAnswers,
      });
    },
    [control, answerValues],
  );

  return (
    <Fragment>
      <Label>Answers</Label>
      <SortableList lockAxis="y" distance={2} onSortEnd={sort => onSortEnd(sort)} useDragHandle={true} helperClass="z5000">
        {answers.map((ctrl, index) => {
          return <SortableScenarioAnswerItem key={index} index={index} ctrl={ctrl} form={control} i={index} />;
        })}
      </SortableList>
    </Fragment>
  );
});

interface ScenarioAnswerItemProps {
  i: number;
  ctrl: ScenarioAnswerForm;
  form: ScenarioForm;
}

const ScenarioAnswerItem = memo((props: ScenarioAnswerItemProps) => {
  const { ctrl, form, i } = props;

  const DragHandle = SortableHandle(() => <i className="fas fa-grip-vertical font-size-16 mr-3 mb-3" style={{ cursor: 'move' }}></i>);

  return (
    <div>
      <Row key={`question-${i} mb-2 mt-2`}>
        <Col md={8} className="input-width">
          <DragHandle />
          <FormInput control={ctrl.controls.option} />
        </Col>
        <Col md={2} className="mt-2">
          <FormRadioGroup control={form.controls.correntAnswerIndex}>
            <FormRadio label={'Correct Answer'} value={i} />
          </FormRadioGroup>
        </Col>
        <Col md={2}>
          {!i && (
            <a className="btn btn-outline-primary btn-sm" onClick={() => form.controls.answers.push()}>
              Add Answer
            </a>
          )}
          {!!i && (
            <a className="btn btn-outline-danger btn-sm" onClick={() => form.controls.answers.removeAt(i)}>
              <i className="bx bx-x"></i>
            </a>
          )}
        </Col>
      </Row>
    </div>
  );
});

export const SortableScenarioAnswerItem = SortableElement(ScenarioAnswerItem);